export function getLogo (id) {
  let result;
  if(id=='60a8acb67418a3429476cd42') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs-logo.png', height: 60};
  else if(id=='62a95796d863cc07ac031227') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhc-logo.png', height: 60};
  else if(id=='63bb7cf44a0f8e3eefe19803') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lht-logo.png', height: 70};
  else if(id=='60ab15046ef2b65b292b215d') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhls-logo.png', height: 60};
  else if(id=='62b4331045dc085e6430d3ce') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alp-logo.png', height: 100};
  else if(id=='69025596a9a451a70b3e2014') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alpm-logo.png', height: 100};  
  else if(id=='60b07f300d820029acae4734') result = {src: 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alh-logo.png', height: 60};
  else result = '';
  return result;
}

export function getStatusColor (status) {
  let result;
  if(status=='New') result = 'primaryConst white--text';
  else if(status=='Accept') result = 'lightPinkConst white--text';
  else if(status=='Accepted') result = 'lightPinkConst white--text';
  else if(status=='Approve') result = 'darkGreenConst white--text';
  else if(status=='Approved') result = 'darkGreenConst white--text';
  else if(status=='Active') result = 'darkGreenConst white--text';
  else if(status=='Assigned') result = 'yellowConst white--text';
  else if(status=='Audit') result = 'redConst white--text';
  else if(status=='Complete') result = 'successConst white--text';
  else if(status=='Completed') result = 'successConst white--text';
  else if(status=='Credit') result = 'orangeConst white--text';
  else if(status=='Inactive') result = 'greyTint white--text';
  else if(status=='Partial') result = 'yellowConst white--text';
  else if(status=='Pending') result = 'lightPinkConst white--text';
  else if(status=='Posted') result = 'purpleConst white--text';
  else if(status=='Processing') result = 'lightPinkConst white--text';
  else if(status=='Sent') result = 'lightBlueConst white--text';
  else if(status=='Void') result = 'greyTint white--text';
  else if(status=='Working') result = 'hotPinkConst white--text';
  else result = 'secondaryConst white--text';
  return result;
}

export function formatHtmlText (text) {
  let result = text;
  result = result.replaceAll("<p>", "<p style='line-height: 1; font-size: 17px;'>");
  result = result.replaceAll("<li>", "<li style='font-size: 16px;'>");
  return result;
}

export function getTimeZone (id) {
  let result;
  if(id=='60a8acb67418a3429476cd42') result = 'Asia/Singapore';
  else if(id=='60b07f300d820029acae4734') result = 'Asia/Yangon';
  else if(id=='60ab15046ef2b65b292b215d') result = 'Asia/Yangon';
  else if(id=='62b4331045dc085e6430d3ce') result = 'Asia/Bangkok';
  else if(id=='63bb7cf44a0f8e3eefe19803') result = 'Asia/Bangkok';
  else if(id=='62a95796d863cc07ac031227') result = 'Asia/Yangon';
  
  else result = 'Asia/Singapore';
  return result;
}

export function formatStdDate(date) {
  if(date==null) return null;
  let d = new Date(date);
  let month;
  let day;
  if(d.getMonth()<=8) month = "0" + (d.getMonth()+1).toString();
  else month = (d.getMonth()+1).toString();
  if(d.getDate()<10) day = "0" + d.getDate().toString();
  else day = d.getDate().toString();

  let result = d.getFullYear().toString() + '-' + month + '-' + day;
  return result;
}

export function formatMonth(date) {
  if(date==null) return null;
  let d = new Date(date);
  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let result = months[d.getMonth()] + '-' + d.getFullYear().toString();
  return result;
}

export function formatShortDate(date) {
  if(date==null) return null;
  let d = new Date(date);
  let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let result = months[d.getMonth()] + ' ' + d.getDate().toString();
  return result;
}

export function formatShortDay(date) {
  if(date==null) return null;
  let d = new Date(date);
  let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let result = days[d.getDay()];
  return result;
}

export function formatDay(date) {
  if(date==null) return null;
  let d = new Date(date);
  let days = ['Sunday', 'Monday', 'Tueday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  let result = days[d.getDay()];
  return result;
}

export function getFirstDay(date) {
  if(date==null) return null;
  let d = new Date(date);
  let month;
  let day = '01';
  if(d.getMonth()<=8) month = "0" + (d.getMonth()+1).toString();
  else month = (d.getMonth()+1).toString();

  let result = d.getFullYear().toString() + '-' + month + '-' + day;
  return result;
}

export function getLastDay(date) {
  if(date==null) return null;
  let d = new Date(date);
  var d1 = new Date(d.getFullYear(), d.getMonth()+1, 0);
  let month;
  let day;

  if(d1.getMonth()<=8) month = "0" + (d1.getMonth()+1).toString();
  else month = (d1.getMonth()+1).toString();
  if(d1.getDate()<10) day = "0" + d1.getDate().toString();
  else day = d1.getDate().toString();

  let result = d1.getFullYear().toString() + '-' + month + '-' + day;
  return result;
}

export function getDay15(date){
  var d0 = new Date(date); 
  var d1 = formatStdDate(d0);
  let d2 = new Date(new Date(d1).getTime()+(14*24*60*60*1000));
  let result = formatStdDate(d2);
  return result;
}


export function getServerDate(input) {
  var date = new Date(input)
  var newDate = new Date(date.getTime() + 8*60*1000);

  var offset = date.getTimezoneOffset() / 60;
  var hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;   
}

export function groupBy (data, funct, groupid) {
  if(data==null) return;
  let results = [];
  let groups = Object.groupBy(data, funct);
  for(var key of Object.keys(groups)){
      let obj = {};
      obj[groupid] = key;
      let result = Object.assign(obj, groups[key]);
      results.push(result);
  }
  return groups;
}

export function sortDataAsc(data, sort_field) {
  if(data==null || data.length==0) return;
  data.sort((a,b) =>{
    if (b[sort_field] > a[sort_field]) return -1;
    if (a[sort_field] < b[sort_field]) return 1;
    return 0;
  });
  return;
}

export function sortDataDsc(data, sort_field) {
  if(data==null || data.length==0) return;
  data.sort((a,b) =>{
    if (b[sort_field] < a[sort_field]) return -1;
    if (a[sort_field] > b[sort_field]) return 1;
    return 0;
  });
  return;
}


export function formatCurrency ( input ) {
  if(input==null) return 0;
  let result = parseFloat(input);
  result = result.toFixed(2)
  result = result.toLocaleString("en-SG", { maximumFractionDigits: 2 });
  return result;
}


export const Tools = {
    methods: {
      groupBy,
      getLogo,
      formatHtmlText,
      formatStdDate,
      formatShortDate,
      getTimeZone,
      getServerDate,
      sortDataAsc,
      formatCurrency,
    }
};